import { createContext } from 'react';

import { User } from '@/types/user';

export type AuthorisedCustomerCompanyUserContextValue = {
  isCustomerCompanyUserAuthorized: boolean;
  isError: boolean;
  setHasTriedToLogin: (hasTriedToLogin: boolean) => void;
  hasTriedToLogin: boolean;
  companyUser: User | undefined;
};

const defaultContextValue: AuthorisedCustomerCompanyUserContextValue = {
  isCustomerCompanyUserAuthorized: false,
  isError: false,
  setHasTriedToLogin: () => false,
  hasTriedToLogin: false,
  companyUser: undefined,
};

export const AuthorisedCustomerCompanyUserContext =
  createContext<AuthorisedCustomerCompanyUserContextValue>(defaultContextValue);
